import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import AddToCart from '@components/shared/AddToCart';
import Colors from '@components/shared/Colors';
import { StyledLinkWrapper } from '@components/shared/SharedStyles';
import { CartItem } from '@contracts';
import { ButtonTypesCatalogue, ProductData } from '@data/storefront';
import Button from '../shared/Button';

interface ProductShopButtonProps {
  data: ProductData;
  cartItem: CartItem | null | undefined;
  link: string;
  navigateToProduct: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const ProductShopButton: React.FC<ProductShopButtonProps> = ({ data, cartItem, link, navigateToProduct }) => {
  const { t } = useTranslation();

  switch (data.button_type) {
    case ButtonTypesCatalogue.AddToCart:
      return <AddToCartStyled cartItem={cartItem} data-testid="product-box-button" />;
    default:
      return (
        <StyledLinkWrapper to={link} onClick={(e: any) => navigateToProduct(e)} role="product-link">
          <ButtonStyled data-testid="product-box-button">{t(`components.${data.button_type}`)}</ButtonStyled>
        </StyledLinkWrapper>
      );
  }
};

export default ProductShopButton;

const AddToCartStyled = styled(AddToCart)`
  background: ${Colors.pink};
  color: ${Colors.cream};
  display: flex;
  position: absolute;
  width: auto;
  height: 45px;
  left: 30px;
  right: 30px;
  bottom: 30px;
  padding: 0 10px;
  align-items: center;
  justify-content: center;
  font-family: 'BrownStd';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const ButtonStyled = styled(Button)`
  background: ${Colors.pink};
  color: ${Colors.cream};
  display: flex;
  position: absolute;
  width: auto;
  height: 45px;
  bottom: 30px;
  left: 30px;
  right: 30px;
  padding: 0 10px;
  align-items: center;
  justify-content: center;
  font-family: 'BrownStd';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;
